<template>
	<div class="footer" v-if="onlineServer">
		<!-- <el-badge :value="unreadByAdmin" :max="9999999" type="danger" class="service" :style="{ top: y + 'px' }">
			<img src="../assets/img/service.gif" ref="draggable" alt="客服" @mousedown="startDrag" @click="toService"
				id="jsGif" />
		</el-badge> -->

		<el-badge :value="unreadByAdmin > 0 ? unreadByAdmin : null" :max="9999999" type="danger" class="service"
			:style="{ top: y + 'px' }">
			<img src="../assets/img/service.gif" ref="draggable" alt="客服" @mousedown="startDrag" @click="toService"
				id="jsGif" />
		</el-badge>

	</div>
	<audio id="audioID2" ref="audio" class="aud" @ended="audioEnded">
		<source :src="audio" />
	</audio>
</template>
<script>
	import {
		modifyPassword
	} from '../api/userIndex';
	import axios from 'axios';
	export default {
		data() {
			return {
				isDragging: false,
				x: '',
				y: '',
				initialY: '',
				elementWidth: '',
				elementHeight: '',
				leftList: [],
				phone: '',
				calculateLatestUnread: false,
				unreadByAdmin: 0,
				unreadByUser: '',
				onlineServer: localStorage.getItem('onlineServer'),
				audio: new Audio('https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/kf-notice/qq.mp3'),
			};
		},
		methods: {
			startDrag(event) {
				this.isDragging = true;
				let rect = this.$refs.draggable.getBoundingClientRect();
				this.initialX = event.clientX - rect.left;
				this.initialY = event.clientY - rect.top;
				document.addEventListener("mousemove", this.onDrag);
				document.addEventListener("mouseup", this.stopDrag);
				event.preventDefault();
			},
			onDrag(event) {
				if (!this.isDragging) return;
				let newX = event.clientX - this.initialX;
				let newY = event.clientY - this.initialY;
				newX = Math.max(0, Math.min(newX, window.innerWidth - this.elementWidth));
				newY = Math.max(0, Math.min(newY, window.innerHeight - this.elementHeight));
				this.x = newX;
				this.y = newY;
			},
			stopDrag() {
				this.isDragging = false;
				document.removeEventListener("mousemove", this.onDrag);
				document.removeEventListener("mouseup", this.stopDrag);
			},
			toService() {
				this.$router.push('/service');
			},
			resetGif() {
				const gif = document.getElementById('jsGif');
				const src = gif.src;
				gif.src = '';
				gif.src = src;
				this.getFetchList();
			},
			async getFetchList() {
				try {
					const response = await fetch(
						`/webket/customer-service/admin/sessions?currentUserId=${localStorage.getItem('user')}&totalSize=${this.leftList.length}&phone=${this.phone}&calculateLatestUnread=${this.calculateLatestUnread}`
					);
					if (response.ok) {
						this.calculateLatestUnread = false;
						let result = await response.json();
						// console.log(result, '我是所有页面的，10s一次')
						if (localStorage.getItem('ms_role') == 'normal') {
							this.unreadByAdmin = result.customData.unreadByUser;
						} else {
							this.unreadByAdmin = result.customData.unreadByAdmin;
						}
						// this.unreadByUser = result.customData.unreadByUser;
					} else {
						console.error("获取会话列表失败:", response.status, response.statusText);
					}
				} catch (error) {
					console.error("网络请求失败:", error);
				}
			}
		},
		created() {
			setInterval(this.resetGif, 10000);
			this.getFetchList();
		},
		mounted() {

		},
	};
</script>
<style scoped>
	.service {
		position: fixed;
		bottom: 80px;
		right: -20px;
		z-index: 999;

	}

	.service img {
		width: 91px;
		height: 116px;
		transform: rotateY(180deg);
		transition: 0.2s linear;
		will-change: transform;
		image-rendering: -webkit-optimize-contrast;
	}

	.service:hover {
		right: 0px;
		transition: 0.2s linear;
	}

	/deep/.el-badge__content.is-fixed {
		right: 108px;
		top: -6px;
	}
</style>